import React from 'react';
import Header from './components/header';
import Footer from './components/footer';
import Programas from './components/programas';
import Aplicacion from './components/aplicacion';
import Inicio from './components/inicio';
import { Box, Typography } from '@mui/material';

function App() {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Header />
      <Box
          sx={{
            mt: { xs: '70px', sm: '90px', md: '120px' }, // margen más reducido
            px: 2,
          }}
        >
        <Typography variant="h3" fontWeight="bold" align="center">
          Bienvenido a Radio Chukuta Comunicaciones
        </Typography>
        <Typography align="center">
          Aquí puedes escuchar música, informarte, y conectarte con la cultura paceña.
        </Typography>
        <Inicio/>
        <Programas />
        <Aplicacion />
      </Box>


      <Footer />
    </Box>
  );
}

export default App;
